import logo from './logo.svg';
import './App.css';
import 'survey-core/defaultV2.min.css';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import {useCallback, useEffect, useRef, useState} from 'react';
import {
  ColumnDirective,
  ColumnsDirective,
  RangeDirective,
  RangesDirective,
  SheetDirective,
  SheetsDirective,
  SpreadsheetComponent
} from "@syncfusion/ej2-react-spreadsheet";
import {L10n, select} from "@syncfusion/ej2-base";
import * as React from 'react';
import {DialogComponent} from "@syncfusion/ej2-react-popups";
import axios from "axios";


// let data = [
//   {
//     '大题编号': '',
//     '小题编号': '',
//     '属性1：语文层面': '',
//     '属性2：语文情景': '',
//     '属性3：语文能力/素养类型': '',
//     '属性4：语文知识内容': '',
//     '属性5：语文核心价值': '',
//     '': '',
//     '': '',
//     '': '',
//     '': '',
//     '': ''
//   }]


let data = [];

L10n.load({
  'cn-ZH': {
    'spreadsheet': {
      'File': '文件',
      'Home': '首页',
      'Insert': '插入',
      'Formulas': '公式',
      'Data': '数据',
      'View': '视图',
      'Cut': '剪切',
      'Copy': '拷贝',
      'Paste': '粘贴',
      'PasteSpecial': '特殊粘贴',
      'All': '全部',
      'Values': '数值',
      'Formats': '格式',
      'Font': '字体',
      'FontSize': '字体大小',
      'Bold': '粗体',
      'Italic': '斜体',
      'Underline': '下划线',
      'Strikethrough': '删除线',
      'TextColor': '文本颜色',
      'FillColor': '填充颜色',
      'HorizontalAlignment': '水平对齐',
      'AlignLeft': '左对齐',
      'AlignCenter': '居中对齐',
      'AlignRight': '右对齐',
      'VerticalAlignment': '垂直对齐',
      'AlignTop': '顶部对齐',
      'AlignMiddle': '垂直中间对齐',
      'AlignBottom': '底部对齐',
      'InsertFunction': '插入函数',
      'Delete': '删除',
      'Rename': '重命名',
      'Hide': '隐藏',
      'Unhide': '显示',
      'NumberFormat': '数字格式',
      'New':'新建',
      'Open':'打开',
      'SaveAs':'另存为'
    }
  }
});
let sdata = {};

function App(props) {
  // const [survey, setSurvey] = useState(new Model({}));
  const [surveyData, setSurveyData] = useState(new Model({}));




  const alertResults = useCallback((sender) => {
    // const results = JSON.stringify(sender.data);
    // alert(results);
    const rt = sender.data;
    console.log(rt);
    let spreadsheet = spreadsheetRef.current;

    // spreadsheet.insertRow([{
    //   index:1,
    //   cells:[{value:'a'},{value:'b'},{value:'c'}]
    // }]);

    //alert(spreadsheet.selectionModule.startCell);

    spreadsheet.insertRow([{
      index:spreadsheet.selectionModule.startCell[0],
      cells:[
        {value:rt.c1},
        {value:rt.c2?rt.c2:''},
        {value:rt.s1},
        {value:rt.s2},
        {value:rt.s3},
        {value:rt.s4},
        {value:rt.s5},
        {value:rt.s6},
        {value:rt.s7},
        {value:rt.s8?rt.s8:'0.00'},
        {value:rt.s9?rt.s9:'0.00'},
        {value:rt.s10?rt.s10:'0.00'}
      ]
    }]);
  },[]);


  const rangeRef = useRef(null);
  const spreadsheetRef = useRef(null);


  useEffect(() => {
console.log('effect');

  axios.get('./' + props.file)
      .then(response => {
        sdata = response.data;
        const updatedSurveyData = new Model(sdata);
        updatedSurveyData.onComplete.add(alertResults);
        setSurveyData(updatedSurveyData);

        let obj = {};
        const ele = response.data.pages[0].elements;
        // for(let i = 0; i < ele.length; i++){
        //   obj[ele[i].title] = '';
        // }
        // data = [obj];
        //console.log(data);


        let spreadsheet = spreadsheetRef.current;
        if (spreadsheet) {
          spreadsheet.cellFormat({fontWeight: 'bold', textAlign: 'center'}, 'A1:L1');
          for (let i = 0; i < ele.length; i++) {
            let letter = String.fromCharCode(65 + i);
            spreadsheet.updateCell({value: ele[i].title}, letter + '1');
          }
        }

      })
      .catch(err => {
        console.error(err);
      });

  let spreadsheet = spreadsheetRef.current;
  if (spreadsheet) {


    // spreadsheet.updateCell({value:'a'}, 'A1');
    // Hiding the `Insert` from ribbon.
    // spreadsheet.hideRibbonTabs(['Insert']);
    // Set disabled state to `View` ribbon tab.
    // spreadsheet.enableRibbonTabs(['View'], false);
    // Adding the `Help` ribbon tab at the last index.
    // Specify the ribbon tab header text in last optional argument(`insertBefore`) for inserting new tab before any existing tab.
    // spreadsheet.addRibbonTabs([{
    //   header: { text: 'Help' }, content: [{
    //     text: 'Feedback', tooltipText: 'Feedback',
    //     click: () => { /* Any click action for this toolbar item will come here. */
    //       alert('a');
    //     }
    //   }]
    // }]);
    // Hiding the unwanted toolbar items from `Home` by specifying its index.
    // spreadsheet.hideToolbarItems('Home', [0, 1, 2, 4, 14, 15, 21, 24]);
    // Set disable state to `Underline`, 'Wrap text` toolbar items from `Home` by specifying the item id.
    // spreadsheet.enableToolbarItems('Home', [`${spreadsheet.element.id}_underline`, `${spreadsheet.element.id}_wrap`], false);
    // Set disable state to `Protect Sheet` toolbar item from `Data` by mentioning its index.
    // spreadsheet.enableToolbarItems('Data', [0], false);
    // Adding the new `Custom Formulas` toolbar item under `Formulas` tab for adding custom formulas.
    console.log('ok');

    spreadsheet.addToolbarItems('Insert', [{type: 'Separator'}, {
      text: '在当前行插入试题评价', tooltipText: '在当前行插入一个试题评价',
      // You can set click handler for each new custom toolbar item
      click: () => {
        // data = [
        //   {
        //     'Customer Name': 'Clare Batterton',
        //     'Model': 'Sparrow',
        //     'Color': 'Pink',
        //     'Payment Mode': 'Cash On Delivery',
        //     'Delivery Date': '7/13/2016',
        //     'Amount': '17866.19'
        //   }];


        // spreadsheet.insertRow([{
        //   index:1,
        //   cells:[{value:'a'},{value:'b'},{value:'c'}]
        // }]);

        //alert(spreadsheet.selectionModule.startCell);
        if (spreadsheet.selectionModule.startCell === undefined || spreadsheet.selectionModule.startCell[0] === 0) {
          alert('不能选择第一行！请选择需要插入的行！');
        } else {
          const updatedSurveyData = new Model(sdata);
          updatedSurveyData.onComplete.add(alertResults);
          setSurveyData(updatedSurveyData);

          setStatus({hideDialog: true});
        }


      }
    }]);
    // Adding new custom item `Import` after the existing `Open` item. By default, new item will add after the specified item.
    spreadsheet.addFileMenuItems([{text: 'Import', iconCss: 'e-open e-icons'}], 'Open');
    spreadsheet.addFileMenuItems([{text: 'Import', iconCss: 'e-open e-icons'}], 'Open');
    // Adding new custom item `Export As` after the existing `Save As` item.
    // Set `insertAfter` optional argument as `false` for adding new item before the specified item.
    spreadsheet.addFileMenuItems([{
      text: 'Export As',
      iconCss: 'e-save e-icons',
      items: [{text: 'Import', iconCss: 'e-open e-icons'}, {text: 'XLSX', iconCss: 'e-xlsx e-icons'},
        {text: 'XLS', iconCss: 'e-xls e-icons'}, {text: 'CSV', iconCss: 'e-csv e-icons'}]
    }], 'Save As', false);


  }

  return () => {
    // Cleanup: remove event listener
    if (surveyData && surveyData.onComplete) {
      surveyData.onComplete.remove(alertResults);
    }
  };


  }, []);
  const fileMenuBeforeOpen = () => {
    // Because the file menu items are created dynamically, you need to perform the hide or show and enable/disable operations
    // under filemenu before open event.
    // Hiding the `Save As` and `Open` item.
    let spreadsheet = spreadsheetRef.current;
    //debugger;
    if (spreadsheet) {
      //spreadsheet.hideFileMenuItems(['Save As', 'Open']);
      // Set disable state to `New` item. You can perform any file menu items customization by specifying the item id,
      // if it has more than one same item text. Set the last argument `isUniqueId` as true for using the item id.
      //spreadsheet.enableFileMenuItems([`${spreadsheet.element.id}_New`], false, true);
    }
  };
  const fileMenuItemSelect = (args) => {
    let spreadsheet = spreadsheetRef.current;
    // Custom file menu items select handler
    switch (args.item.text) {
      case 'Import': select(`#${spreadsheet.element.id}_fileUpload`, spreadsheet.element).click();
        break;
      case 'XLSX': if (spreadsheet) { spreadsheet.save({ saveType: 'Xlsx' }) };
        break;
      case 'XLS': if (spreadsheet) { spreadsheet.save({ saveType: 'Xls' }) };
        break;
      case 'CSV': if (spreadsheet) { spreadsheet.save({ saveType: 'Csv' }) };
        break;
      default:
        break;
    }
  };
  const [status, setStatus] = useState({ hideDialog: false });


  function dialogClose() {
    setStatus({ hideDialog: false })
  }

  let buttons = [
    {
      buttonModel: {
        content: '取消',
        cssClass: 'e-flat'
      },
      'click': () => {
        setStatus({ hideDialog: false });
      }
    }];


  return (
    <div className="App" style={{height:"100%"}}>

      <SpreadsheetComponent locale='cn-ZH' ref={spreadsheetRef} fileMenuBeforeOpen={fileMenuBeforeOpen} fileMenuItemSelect={fileMenuItemSelect}
                            showFormulaBar={true} showSheetTabs={true} allowInsert={true} allowDelete={true} allowMerge={true}
                            openUrl="https://services.syncfusion.com/react/production/api/spreadsheet/open"
                            saveUrl="https://services.syncfusion.com/react/production/api/spreadsheet/save">
        <SheetsDirective>
          <SheetDirective>
            <RangesDirective>
              <RangeDirective ref={rangeRef}></RangeDirective>
            </RangesDirective>
            <ColumnsDirective>
              <ColumnDirective width={100}></ColumnDirective>
              <ColumnDirective width={100}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
              <ColumnDirective width={180}></ColumnDirective>
            </ColumnsDirective>
          </SheetDirective>
        </SheetsDirective>
      </SpreadsheetComponent>

      <DialogComponent width='800px' isModal={true} target='.App' visible = {status.hideDialog} close = {dialogClose} showCloseIcon={true} header='题目属性选单' allowDragging={true} closeOnEscape={false}  buttons={buttons}>

        <Survey model={surveyData} />

      </DialogComponent>

    </div>
  );
}

export default App;
